export default __webpack_public_path__ + "static/media/who_we_are_responsive_mobile.b3c06c4d.webp";